import React, { FC } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import styles from './DialComponent.module.scss';
import DialLabelComponent from '../DialLabelComponent/DialLabelComponent';
import boddVariables from '../../../variables.module.scss';
import { clamp, WellnessItem } from '../../../services/DataFormatService';

interface DialComponentProps {
    wellnessItem: WellnessItem,
}

const DialComponent: FC<DialComponentProps> = (props) => {
    const { wellnessItem } = props;
    const degrees = clamp(((wellnessItem.value - wellnessItem.min!) / (wellnessItem.max! - wellnessItem.min!)) * 260, 260); // dial goes from 0 to 260
    const radians = (degrees + 140) * (Math.PI / 180);
    const radius = 60;
    const xPos = radius * Math.cos(radians);
    const yPos = radius * Math.sin(radians);
    const valLeft = xPos;
    const valTop = yPos + 43;

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            spacing={1}
            className={styles.DialComponent}
            data-testid="DialComponent"
            sx={{ pb: 4, minWidth: '120px' }}
        >
            <Typography
                sx={{
                    fontFamily: 'Poppins',
                    fontWeight: '500',
                    fontSize: '16px',
                    lineHeight: '21px',
                    color: '#000000',
                    mx: 1.5,
                    pb: 1,
                    minHeight: '42px',
                    textAlign: 'center',
                }}
            >
                {wellnessItem.name}
            </Typography>
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                className={styles.DialImage}
            >
                <Box
                    sx={{
                        height: 10,
                        width: 10,
                        border: '2px',
                        borderStyle: 'solid',
                        borderColor: boddVariables.grey600,
                        backgroundColor: boddVariables.black,
                        position: 'relative',
                        left: `${valLeft}px`,
                        borderRadius: '50%',
                        top: `${valTop}px`,
                    }}
                />
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '600',
                        fontSize: '22px',
                        lineHeight: '28px',
                        color: '#000000',
                        mt: 2,
                        textAlign: 'center',
                    }}
                >
                    {wellnessItem.formattedValue}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                        color: '#5E5D5A',
                        textAlign: 'center',
                    }}
                >
                    {wellnessItem.unitLabel ?? ''}
                </Typography>
            </Stack>
            <Stack direction="row" justifyContent="center" alignSelf="stretch">
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                        color: boddVariables.black,
                        mr: '30px',
                    }}
                >
                    {wellnessItem.min}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontWeight: '400',
                        fontSize: '12px',
                        lineHeight: '18px',
                        color: boddVariables.black,
                        ml: '30px',
                    }}
                >
                    {wellnessItem.max}
                </Typography>
            </Stack>
            {wellnessItem.dialGroup && <DialLabelComponent dialGroup={wellnessItem.dialGroup} />}
        </Stack>
    );
};

export default DialComponent;
